import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import ProductCardItem from "./ProductCard";
import productsListStorage from "../../storages/productsListStorage";
import layoutStorage from "../../storages/layoutStorage";
import BlackButton from "../../UI/atoms/buttons/BlackButton";
import LinkButton from "../../UI/atoms/buttons/LinkButton/LinkButton";

class ProductCardList extends Component {
  componentDidMount() {
    // const { listField } = this.props
    // if (productsListStorage[listField] && productsListStorage[listField] ==0) productsListStorage.loadProducts();
  }

  render() {
    const { listField, limit, t } = this.props;
    // console.log("FIELDDDDD", listField);
    // console.log("WREST", productsListStorage[listField]);
    return (
      <div className="sorting-collections__products row ml-5">
        {productsListStorage[listField] &&
          productsListStorage[listField].length === 0 && (
            <div
              style={{
                fontSize: "22px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                minHeight: 300,
              }}
            >
              <div className="d-flex flex-column">
                <div className="mb-25">{t("Empty product list")}</div>
                <div className="mb-10 d-flex justify-content-center">
                  <LinkButton href="123">{t("HOME")}</LinkButton>
                </div>
              </div>
            </div>
          )}
        {productsListStorage[listField] &&
          productsListStorage[listField]
            // .slice(0, limit)
            .map((refNum, index) => (
              // console.log("WREST", refNum);
              <ProductCardItem
                key={`pc-${refNum}-${index}` || `pc-null-${index}`}
                refNum={refNum}
                columns={layoutStorage.catalogLayout.columns}
              />
            ))}
      </div>
    );
  }
}

ProductCardList.defaultProps = {
  limit: 1000,
};
ProductCardList.propTypes = {
  listField: PropTypes.string.isRequired,
  limit: PropTypes.number,
};

export default withTranslation()(observer(ProductCardList));
